export const normalizeAdaptedStatus = (value) => {
  if (typeof value === "boolean") return value
  if (value === 1 || value === "1") return true
  if (value === 0 || value === "0") return false
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase()
    if (["true", "yes", "adapted"].includes(normalized)) return true
    if (["false", "no", "not adapted"].includes(normalized)) return false
  }
  return null
}
